import getOperatingSystem from './utils';

export const DOWNLOAD_APP_LINK = 'https://modernanimal.app.link/lvuB4tquqDb';

// Avoid target issues on some mobile browsers by opening in the same tab
export const HREF_TARGET = getOperatingSystem() === 'Desktop' ? '_blank' : '_self';

export const BREAKPOINTS = { mobile: 0, desktop: 736 };
